<template>
  <div>
    <purchase-list-supplier-offer-wuling
      v-if="isWuling"
      ref="wuling"
      :table-data="tableData"
      :item-schema-list="itemSchemaList"
      :operation="operation"
      :quote-form-disabled="quoteFormDisabled"
      :is-supplier="isSupplier"
      :is-dollar="isDollar"
      :current-round="currentRound"
      :require-tax="requireTax"
      :hide-tax-rate="hideTaxRate"
      @updateTable="updateTable"
    />
    <purchase-list-supplier-offer-default
      v-else
      ref="default"
      :table-data="tableData"
      :item-schema-list="itemSchemaList"
      :operation="operation"
      :quote-form-disabled="quoteFormDisabled"
      :is-supplier="isSupplier"
      :is-dollar="isDollar"
      :current-round="currentRound"
      :require-tax="requireTax"
      :hide-tax-rate="hideTaxRate"
      @updateTable="updateTable"
    />
  </div>
</template>

<script>
// 组件
import PurchaseListSupplierOfferDefault from './default.vue'
import PurchaseListSupplierOfferWuling from './wuling.vue'

/**
 * @description 采购清单供应商报价表格（统一入口）
 */
export default {
  name: 'PurchaseListSupplierOffer',

  components: {
    PurchaseListSupplierOfferDefault,
    PurchaseListSupplierOfferWuling
  },

  props: {
    // 是否是五菱发布的项目
    isWuling: {
      type: Boolean,
      default: false
    },

    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 操作模式
    operation: {
      type: String,
      default: 'detail'
    },

    // 报价单是否可编辑
    quoteFormDisabled: {
      type: Boolean,
      default: false
    },

    // 是否是在供应商视角
    isSupplier: {
      type: Boolean,
      default: false
    },

    // 当前报价轮次信息
    currentRound: {
      type: Object,
      default: () => {}
    },

    // 报价是否含税
    requireTax: {
      type: Boolean,
      default: false
    },

    // 是否隐藏税率
    hideTaxRate: {
      type: Boolean,
      default: false
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updateTable(list) {
      this.$emit('updateTable', list)
    }
  }
}
</script>

<style scoped lang="scss"></style>
